import dayjs from 'dayjs';

function compareChoiceArrays (arr1, arr2) {

	if (arr1.length !== arr2.length) return false;

	function sortChoiceArray (array) {
		return array.sort((a, b) => {
			if (a.choiceId === b.choiceId) {
				return a.ingredientId - b.ingredientId;
			}
			return a.choiceId - b.choiceId;
		});
	}

	const arr1Copy = sortChoiceArray([...arr1]);
	const arr2Copy = sortChoiceArray([...arr2]);

	return arr1Copy.reduce((bool, choiceObject, index) => {
		return bool && choiceObject.choiceId === arr2Copy[index].choiceId && choiceObject.ingredientId === arr2Copy[index].ingredientId;
	}, true);
}

export default {

	getRequiredSalesData (state) {
		return state.requiredSalesData
	},
	getBasket (state) {
		return state.basket
	},
	getBasketCount ( state, getters ) {
		return state.basket.lines.reduce((sum, basketLine) => {
			return sum += basketLine.quantity;
		},0);
	},
	getBasketIndex (state) {
		return lineItem => {
			return state.basket.lines.findIndex(basketItem => {
				return basketItem.ingredientId === lineItem.ingredientId &&
					basketItem.portionTypeId === lineItem.portionTypeId &&
					compareChoiceArrays(basketItem.choiceLines, lineItem.choiceLines);
			});
		}
	},
	getBasketIndexesFromIngredientId (state) {
		return productId => {
			return state.basket.lines.reduce((indexesArray, basketItem, index) => {
				if (basketItem.ingredientId === productId || basketItem.choiceLines.find(choiceLine => choiceLine.ingredientId === productId)) {
					return [...indexesArray, index];
				}
				return indexesArray;
			}, []);
		}
	},
	getBasketTotal ( state, getters ) {
		let total = state.basket.lines.reduce((sum, basketLine) => {
			const productDetails = getters.getProduct(basketLine.ingredientId);
			const itemPrice = productDetails.portions.find(portion => portion.id === basketLine.portionTypeId).price;
			const choiceSum = basketLine.choiceLines.reduce((choiceSum, choice) => {
				const aztecChoice = getters.getProduct(choice.ingredientId);
				return choiceSum + ((aztecChoice.portions && aztecChoice.portions[0] && aztecChoice.portions[0].price) || 0)
			}, 0);
			return sum + basketLine.quantity * itemPrice + basketLine.quantity * choiceSum;
		}, 0);
		total = total || 0;
		return total.toFixed(2)
	},
	getItemCount (state) {
		return productId => {
			return state.basket.lines.reduce((count, basketLine) => {
				return basketLine.ingredientId === productId ? count += basketLine.quantity : count
			}, 0)
		}
	},
	getChoices (state, getters) {
		return productId => {
			let choices = null;
			Object.values(state.menus).forEach(menu => {
				menu.display.displayGroups.forEach(displayGroup => {
					displayGroup.items.forEach(item => {
						if (item.itemType === 'product' && item.product.productId === productId) {
							const aztecProduct = getters.getProduct(item.product.productId);
							choices = aztecProduct && aztecProduct.portions && aztecProduct.portions[0] && aztecProduct.portions[0].choices;
						}
					})
				});
			});
			return choices;
		}
	},
	getChoiceGroup (state) {
		return groupId => {
			let choiceGroupDetail = null;
			Object.values(state.menus).forEach(menu => {
				const cg = menu.aztec.choiceGroups.find(group => {
					return group.id === groupId;
				});
				if (cg) choiceGroupDetail = cg;
			});
			return choiceGroupDetail;
		}
	},
	getDisplayGroupName (state) {
		return productId => {
			let category = null;
			Object.values(state.menus).forEach(menu => {
				menu && menu.display && menu.display.displayGroups && menu.display.displayGroups.forEach(displayGroup => {
					displayGroup && displayGroup.items && displayGroup.items.forEach(item => {
						if (item.itemType === 'product' && item.product && item.product.productId === productId) {
							category = displayGroup;
						}
					})
				});
			});
			return category && category.groupName;
		}
	},
	getDisplayItem (state) {
		return productId => {
			let displayItem = null;
			Object.values(state.menus).forEach(menu => {
				menu.display.displayGroups.forEach(displayGroup => {
					displayGroup.items.forEach(item => {
						if (item.itemType === 'product' && item.product.productId === productId) {
							displayItem = item.product;
						}
					})
				});
			});
			return displayItem;
		}
	},
	getErrorHeading (state) {
		return state.error &&
					 state.error.heading;
	},
	getErrorMessage (state) {
		return state.error &&
					 state.error.message;
	},
	getKeyWord (state) {
		return keywordId => state.menu.display.keywords.find(keyword => {
			return keyword.id === keywordId
		})
	},
	getLineItemsAddedCount (state) {
		return state.lineItemsAddedCount
	},
	getLocation (state) {
		return state.location
	},
	getMatchingBasketItemsChoicesAndPortions (state, getters) {
		return productId => {
			const basketItems = state.basket.lines.filter(basketLine => {
				return basketLine.ingredientId === productId;
			});
			return basketItems.map(item => {
				let itemDetail = {};
				const portions = getters.getProduct(productId).portions;
				if (portions.length > 1) {
					itemDetail.portion = portions.find(portionObject => {
						return portionObject.id === item.portionTypeId;
					}).name;
				}
				itemDetail.quantity = item.quantity;
				itemDetail.choices = item.choiceLines.map(choiceLine => {
					return {
						choiceName: getters.getChoiceGroup(choiceLine.choiceId).displayRecords[0].name,
						selected: getters.getProduct(choiceLine.ingredientId).displayRecords[0].name
					};
				});
				return itemDetail;
			});
		}
	},
	getMenu (state) {
		return menuLabel => {
			return state.menus[menuLabel];
		}
	},
	getMenus (state) {
		return state.menus;
	},
	getPrettyDate (state) {
		let date = dayjs(state.dateTime)
		let today = dayjs()
		let tomorrow = dayjs().add(1, 'day')
		if (date > tomorrow.endOf('day') ||
				date < today.startOf('day')) {
			return dayjs(state.booking.dateTime).format('DD/MM/YYYY')
		}
		if (date > today.endOf('day')) {
			return 'Tomorrow'
		}
		return 'Today'
	},
	getPrettyLocationQuery (state) {
		if (!state.location ||
				!state.location.title) {
			return null
		}
		return state.location.title
	},
	getPreviousTransaction (state) {
		return state.previousTransaction;
	},
	getProduct (state) {
		return productId => {
			let productDetail = null;
			Object.values(state.menus).forEach(menu => {
				const productObject = menu && menu.aztec && menu.aztec.products && menu.aztec.products.find(product => {
					return product.id === productId;
				});
				if (productObject) productDetail = productObject;
			});
			return productDetail;
		}
	},
	getProductSummary (state, getters) {
		return (item) => {
			const meta = getters.getProduct(item.ingredientId);
			const productPrice = meta.portions && meta.portions.length && meta.portions[0].price;

			return {
				quantity: item.quantity,
				SKU: item.ingredientId,
				productName: (meta.displayRecords && meta.displayRecords.length && meta.displayRecords[0].name || '').trim(),
				unitPrice: productPrice
			}
		}
	},
	getZonalSiteId (state) {
		return state.location.zonalSiteId;
	},
	getSiteMeta (state) {
		return {
			siteId: state.requiredSalesData.siteId,
			salesAreaId: state.requiredSalesData.salesAreaId
		}
	},
	getTableNumber (state) {
		return state.requiredSalesData.tableNumber;
	},
	getVoucher (state) {
		return state.basket.voucherLines[0];
	},
	getValidVoucherApplied (state) {
		return state.validVoucherApplied;
	},
	gotAllRequiredSalesData (state) {
		return Object.values(state.requiredSalesData).filter(Boolean).length === 6
	},
	upsellModalDisplayed (state) {
		return state.upsellModalDisplayed;
	}
}
